import React, { memo, useCallback, useEffect, useRef } from "react";
import submit from "submit-form";

export const BarGraphRow = memo(
  ({
    backgroundSize,
    maxValue,
    programCount,
    programId,
    programName,
    setBackgroundSize,
    widthPercentage,
    locals,
  }) => {
    const barRef = useRef();

    // With this, we get the 100% value of the bar biggest bar width,
    // and we use it to correct the background gradient
    const getBackgroundSize = useCallback(() => {
      if (programCount === maxValue && barRef.current) {
        const maxBarWidth = barRef.current.offsetWidth;
        setBackgroundSize(maxBarWidth);
      }
    }, [programCount, maxValue, setBackgroundSize, barRef]);

    useEffect(() => {
      getBackgroundSize();
      window.addEventListener("resize", getBackgroundSize);
      return () => window.removeEventListener("resize", getBackgroundSize);
    }, [maxValue]);

    return (
      <div
        role="h-bar-graph-row"
        className={
          locals.query.selectedProgramId === programId ? "selected" : ""
        }
        onClick={() =>
          submit("/actions/refresh", {
            method: "GET",
            body: {
              selectedProgramId: programId,
            },
          })
        }
      >
        <span>{programName}</span>
        <div
          role="h-bar-graph-bar-wrapper"
          ref={barRef}
          className="mobile-hidden"
        >
          <div
            role="h-bar-graph-bar"
            style={{
              width: `${widthPercentage}%`,
              backgroundSize, // setting this to the full width makes the gradient look the same for all bars
              backgroundImage: `linear-gradient(125deg, var(--gradient-left) -15%, var(--gradient-right) 100%`,
            }}
          />
        </div>
        <span>{programCount}</span>
      </div>
    );
  }
);
